import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, LinkedinIcon, GlobeIcon, ArrowUpRightIcon } from 'lucide-react';
export const Footer = () => {
  return <footer id="contact" className="bg-[#1B2A4A] text-white py-12 md:py-16" data-id="element-118">
      <div className="container mx-auto px-6" data-id="element-119">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-10 md:mb-16" data-id="element-120">
          <div data-id="element-121">
            <div className="mb-6" data-id="element-122">
              <img src="https://cdn.magicpatterns.com/uploads/tV2XtCvVgeGoehCycn1vDo/SS_Logo.png" alt="Sales Source Logo" className="h-16 brightness-0 invert" data-id="element-123" />
            </div>
            <p className="text-white/80 mb-8 leading-relaxed" data-id="element-124">
              Unlock maximum sponsorship revenue with data-driven, outsourced
              sales that deliver predictable results.
            </p>
            <div className="flex space-x-4" data-id="element-125">
              <a href="https://www.linkedin.com/company/sales-source/" className="text-white/60 hover:text-[#B87333] transition-colors" target="_blank" rel="noopener noreferrer" data-id="element-126">
                <LinkedinIcon size={22} data-id="element-127" />
              </a>
            </div>
          </div>
          <div data-id="element-128">
            <h3 className="text-xl font-bold mb-6" data-id="element-129">Contact Us</h3>
            <div className="space-y-5" data-id="element-130">
              <div className="flex items-start gap-4" data-id="element-131">
                <PhoneIcon size={20} className="text-[#B87333] mt-1 flex-shrink-0" data-id="element-132" />
                <p className="text-white/80" data-id="element-133">+31 (0)6 22906971</p>
              </div>
              <div className="flex items-start gap-4" data-id="element-134">
                <MailIcon size={20} className="text-[#B87333] mt-1 flex-shrink-0" data-id="element-135" />
                <p className="text-white/80" data-id="element-136">info@salessource.nl</p>
              </div>
              <div className="flex items-start gap-4" data-id="element-137">
                <GlobeIcon size={20} className="text-[#B87333] mt-1 flex-shrink-0" data-id="element-138" />
                <p className="text-white/80" data-id="element-139">www.salessource.nl</p>
              </div>
              <div className="flex items-start gap-4" data-id="element-140">
                <MapPinIcon size={20} className="text-[#B87333] mt-1 flex-shrink-0" data-id="element-141" />
                <p className="text-white/80" data-id="element-142">Amsterdam, NL</p>
              </div>
            </div>
          </div>
          <div data-id="element-143">
            <h3 className="text-xl font-bold mb-6" data-id="element-144">Quick Links</h3>
            <ul className="space-y-4" data-id="element-145">
              <li data-id="element-146">
                <a href="#services" className="text-white/80 hover:text-[#B87333] transition-colors flex items-center gap-2 group" data-id="element-147">
                  <span data-id="element-148">Services</span>
                  <ArrowUpRightIcon size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-149" />
                </a>
              </li>
              <li data-id="element-150">
                <a href="#process" className="text-white/80 hover:text-[#B87333] transition-colors flex items-center gap-2 group" data-id="element-151">
                  <span data-id="element-152">How It Works</span>
                  <ArrowUpRightIcon size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-153" />
                </a>
              </li>
              <li data-id="element-154">
                <a href="#results" className="text-white/80 hover:text-[#B87333] transition-colors flex items-center gap-2 group" data-id="element-155">
                  <span data-id="element-156">Success Stories</span>
                  <ArrowUpRightIcon size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-157" />
                </a>
              </li>
              <li data-id="element-158">
                <a href="#resources" className="text-white/80 hover:text-[#B87333] transition-colors flex items-center gap-2 group" data-id="element-159">
                  <span data-id="element-160">Resources</span>
                  <ArrowUpRightIcon size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-161" />
                </a>
              </li>
              <li data-id="element-162">
                <a href="#about" className="text-white/80 hover:text-[#B87333] transition-colors flex items-center gap-2 group" data-id="element-163">
                  <span data-id="element-164">About</span>
                  <ArrowUpRightIcon size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-165" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-8 mt-8 border-t border-white/20 text-center text-white/40" data-id="element-166">
          <p data-id="element-167">
            &copy; {new Date().getFullYear()} Sales Source. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};